import React from 'react';

const Location = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2005 1.66675C6.97552 1.66675 4.36719 4.27508 4.36719 7.50008C4.36719 11.8751 10.2005 18.3334 10.2005 18.3334C10.2005 18.3334 16.0339 11.8751 16.0339 7.50008C16.0339 4.27508 13.4255 1.66675 10.2005 1.66675ZM10.2005 9.58341C9.05052 9.58341 8.11719 8.65008 8.11719 7.50008C8.11719 6.35008 9.05052 5.41675 10.2005 5.41675C11.3505 5.41675 12.2839 6.35008 12.2839 7.50008C12.2839 8.65008 11.3505 9.58341 10.2005 9.58341Z" fill="white"/>
  </svg>
);

export default Location;